/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOrder } from '../../models/api-response-order';
import { OrderSalePointRequest } from '../../models/order-sale-point-request';

export interface UpdateOrderSalePoint$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body: OrderSalePointRequest
}

export function updateOrderSalePoint(http: HttpClient, rootUrl: string, params: UpdateOrderSalePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOrder>> {
  const rb = new RequestBuilder(rootUrl, updateOrderSalePoint.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOrder>;
    })
  );
}

updateOrderSalePoint.PATH = '/v1/api/orders/{reference}/sale-point';
